module.exports = __webpack_public_path__ + "static/img/none.5fab593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/none.png
// module id = punY
// module chunks = 1